import { create } from 'zustand'

const SELECTED_TENANT_ID = 'zma_selected_tenant_id'
const SELECTED_TENANT_DATA = 'zma_selected_tenant_data'

interface TenantInfo {
  id: string
  name: string
  miniAppUrl?: string | null
  type: string
}

interface TenantState {
  selectedTenantId: string | null
  selectedTenant: TenantInfo | null
  setSelectedTenant: (tenant: TenantInfo) => void
  clearSelectedTenant: () => void
  initializeTenant: () => void
}

export const useTenantStore = create<TenantState>()((set) => {
  const initializeTenant = () => {
    const savedTenantId = localStorage.getItem(SELECTED_TENANT_ID)
    const savedTenantData = localStorage.getItem(SELECTED_TENANT_DATA)

    let selectedTenant: TenantInfo | null = null
    if (savedTenantData) {
      try {
        selectedTenant = JSON.parse(savedTenantData)
      } catch (_error) {
        selectedTenant = null
        localStorage.removeItem(SELECTED_TENANT_ID)
        localStorage.removeItem(SELECTED_TENANT_DATA)
      }
    }

    set({
      selectedTenantId: savedTenantId,
      selectedTenant: selectedTenant,
    })
  }

  return {
    selectedTenantId: null,
    selectedTenant: null,

    setSelectedTenant: (tenant: TenantInfo) => {
      // Save to localStorage
      localStorage.setItem(SELECTED_TENANT_ID, tenant.id)
      localStorage.setItem(SELECTED_TENANT_DATA, JSON.stringify(tenant))

      set({
        selectedTenantId: tenant.id,
        selectedTenant: tenant,
      })
    },

    clearSelectedTenant: () => {
      // Remove from localStorage
      localStorage.removeItem(SELECTED_TENANT_ID)
      localStorage.removeItem(SELECTED_TENANT_DATA)

      set({
        selectedTenantId: null,
        selectedTenant: null,
      })
    },

    initializeTenant,
  }
})
